/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneStateProviders as ResolvedStandaloneStateProviders } from 'base/components/standalone/StateProviders';

export const StateProviders: typeof ResolvedStandaloneStateProviders = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneStateProviders {...props} />
        </ErrorBoundary>
    );
});

export type StateProvidersProps = PropsFromComponent<typeof StateProviders>;

/** @deprecated Use slot architecture instead */
export const StateProvidersWith = (extras: DynamicStandaloneExtras): typeof StateProviders => {
    return function StateProviders(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'StateProviders');
        return <ResolvedStandaloneStateProviders {...mergeProps({ options: { theme } }, props)} />;
    }
}